import { useTranslation } from "react-i18next";

import { classNames } from "../../../../utils/styles";
import { Container } from "./styles";

type Props = {
  value: number;
  onSelect: (value: number) => void;
};

const ICONS = ["😫", "😕", "😑", "😃", "🤩"];

export const Rating = ({ value, onSelect }: Props) => {
  const { t } = useTranslation();

  return (
    <Container>
      <div className="options" role="radiogroup" aria-label={t("pages.feedback.sections.experience")}>
        {ICONS.map((icon, index) => {
          const option = index + 1;
          return (
            <button
              key={option}
              type="button"
              role="radio"
              aria-checked={option === value}
              aria-label={t(`pages.feedback.rating.${option}`)}
              className={classNames(`value-${option}`, { active: option === value })}
              onClick={() => onSelect(option)}>
              {icon}
            </button>
          );
        })}
      </div>
      <p className="label">{t(`pages.feedback.rating.${value}`)}</p>
    </Container>
  );
};
